
import { IModalState } from './modal-types.store';

export class ModalState implements IModalState {
    config: { [key: string]: boolean };
    constructor() {
        this.config = {};
    }
}

